var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"bc-recommended-message",attrs:{"to":"/recommendations"}},[_vm._v(" "+_vm._s(_setup.t('recommendations.sidebar.recommended'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }